import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../api";

export const getChildCampaigns = createAsyncThunk('child-campaigns', async (id: number) => {
  const response = await axios.get(`/campaigns/${id}/children`);

  return response.data;
});
